export const M2_UNIT_11 = {
  id: "m2-u11",
  title: "Unit 11: House & Furniture",
  topic: "Rooms and Objects",
  iconType: "box", // Usamos 'box' porque son objetos/muebles
  grammarImage: "/m2-u11-grammar.jpg", // Recuerda subir esta imagen a public
  grammarText: "Vocabulario esencial sobre las partes de la casa (Kitchen, Bedroom...) y el mobiliario (Sofa, Table...).",
  sets: [
    {
      id: "u27-set1",
      title: "Set 1: Household Rooms - Basic",
      questions: [
        { type: "mc", q: "You cook here.", options: ["kitchen", "bedroom", "bathroom"], a: "kitchen" },
        { type: "mc", q: "You sleep here.", options: ["bedroom", "living room", "garage"], a: "bedroom" },
        { type: "blank", q: "You wash here: ___ (bathroom).", options: ["bathroom"], a: "bathroom" },
        { type: "mc", q: "You eat here: dining ___", options: ["room", "kitchen", "bedroom"], a: "room" },
        { type: "blank", q: "You watch TV: living ___ (room).", options: ["room"], a: "room" },
        { type: "order", q: "Ordena: kitchen", words: ["kitchen"], a: "kitchen" },
        { type: "mc", q: "Car outside: ___ (garage). True?", options: ["True", "False"], a: "True" },
        { type: "mc", q: "You study here: ___", options: ["study", "kitchen", "bathroom"], a: "study" },
        { type: "blank", q: "Upstairs: ___ (bedroom).", options: ["bedroom"], a: "bedroom" },
        { type: "order", q: "Ordena: living room", words: ["living", "room"], a: "living room" }
      ]
    },
    {
      id: "u27-set2",
      title: "Set 2: Furniture & Objects",
      questions: [
        { type: "mc", q: "Soft seat: ___", options: ["couch", "table", "lamp"], a: "couch" },
        { type: "mc", "q": "Light: ___", options: ["lamp", "chair", "door"], a: "lamp" },
        { type: "blank", q: "Books on: ___ (bookcase).", options: ["bookcase"], a: "bookcase" },
        { type: "mc", q: "You write on: ___", options: ["desk", "bed", "window"], a: "desk" },
        { type: "blank", q: "Sit: ___ (chair).", options: ["chair"], a: "chair" },
        { type: "order", q: "Ordena: armchair", words: ["armchair"], a: "armchair" },
        { type: "mc", q: "TV on: television (True)?", options: ["True", "False"], a: "True" },
        { type: "mc", q: "Eat on: ___", options: ["table", "bed", "lamp"], a: "table" },
        { type: "blank", q: "Hang clothes: ___ (closet).", options: ["closet"], a: "closet" },
        { type: "order", q: "Ordena: dining room table", words: ["dining", "room", "table"], a: "dining room table" }
      ]
    },
    {
      id: "u27-set3",
      title: "Set 3: Kitchen Objects",
      questions: [
        { type: "mc", q: "Cold food: refrigerator (fridge).", options: ["True", "False"], a: "True" },
        { type: "mc", q: "Cook on: ___", options: ["stove", "sink", "table"], a: "stove" },
        { type: "blank", q: "Wash dishes: ___ (sink).", options: ["sink"], a: "sink" },
        { type: "mc", q: "UK: fridge = US: ___", options: ["refrigerator", "oven", "toaster"], a: "refrigerator" },
        { type: "blank", q: "UK: cooker = US: ___ (stove).", options: ["stove"], a: "stove" },
        { type: "order", q: "Ordena: refrigerator", words: ["refrigerator"], a: "refrigerator" },
        { type: "mc", q: "Eat from: plate. True?", options: ["True", "False"], a: "True" },
        { type: "mc", q: "Drink from: ___", options: ["cup", "bowl", "fork"], a: "cup" },
        { type: "blank", q: "Soup in: ___ (bowl).", options: ["bowl"], a: "bowl" },
        { type: "order", q: "Ordena: kitchen sink", words: ["kitchen", "sink"], a: "kitchen sink" }
      ]
    },
    {
      id: "u27-set4",
      title: "Set 4: Bathroom & Bedroom",
      questions: [
        { type: "mc", q: "Shower water: ___", options: ["shower", "bathtub", "toilet"], a: "shower" },
        { type: "mc", q: "Bath water: ___", options: ["bathtub", "sink", "bed"], a: "bathtub" },
        { type: "blank", q: "Toilet: ___ (toilet).", options: ["toilet"], a: "toilet" },
        { type: "mc", q: "Sleep on: ___", options: ["bed", "chair", "desk"], a: "bed" },
        { type: "blank", q: "Window: ___ (window).", options: ["window"], a: "window" },
        { type: "order", q: "Ordena: bathtub", words: ["bathtub"], a: "bathtub" },
        { type: "mc", q: "Closet = wardrobe (UK). True?", options: ["True", "False"], a: "True" },
        { type: "mc", q: "Door to outside: ___", options: ["door", "window", "roof"], a: "door" },
        { type: "blank", q: "Sit in living room: ___ (armchair).", options: ["armchair"], a: "armchair" },
        { type: "order", q: "Ordena: bedroom window", words: ["bedroom", "window"], a: "bedroom window" }
      ]
    },
    {
      id: "u27-set5",
      title: "Set 5: Outside & Upstairs/Downstairs",
      questions: [
        { type: "mc", q: "Car park: ___", options: ["garage", "kitchen", "study"], a: "garage" },
        { type: "mc", q: "Top of house: ___", options: ["attic", "basement", "kitchen"], a: "attic" },
        { type: "blank", q: "Bottom of house: ___ (basement).", options: ["basement"], a: "basement" },
        { type: "mc", q: "US: yard = UK: ___", options: ["garden", "park", "street"], a: "garden" },
        { type: "blank", q: "Go up: ___ (upstairs).", options: ["upstairs"], a: "upstairs" },
        { type: "order", q: "Ordena: downstairs", words: ["downstairs"], a: "downstairs" },
        { type: "mc", q: "Roof on top. True?", options: ["True", "False"], a: "True" },
        { type: "mc", q: "Stairs connect floors.", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Work table: ___ (desk).", options: ["desk"], a: "desk" },
        { type: "order", q: "Ordena: garden", words: ["garden"], a: "garden" }
      ]
    },
    {
      id: "u27-set6",
      title: "Set 6: US vs UK Vocabulary",
      questions: [
        { type: "mc", q: "US: couch = UK: ___", options: ["sofa", "chair", "bed"], a: "sofa" },
        { type: "mc", q: "US: closet = UK: ___", options: ["wardrobe", "desk", "lamp"], a: "wardrobe" },
        { type: "blank", q: "US: block = UK: block of ___ (flats).", options: ["flats"], a: "flats" },
        { type: "mc", q: "US: silverware = UK: ___", options: ["cutlery", "plates", "cups"], a: "cutlery" },
        { type: "blank", q: "US: apartment = UK: ___ (flat).", options: ["flat"], a: "flat" },
        { type: "order", q: "Ordena: refrigerator / fridge", words: ["refrigerator", "(US)", "/fridge", "(UK)"], a: "refrigerator (US) /fridge (UK)" },
        { type: "mc", q: "US: yard = UK: garden. True?", options: ["True", "False"], a: "True" },
        { type: "mc", q: "US: stove = UK: ___", options: ["cooker", "oven", "fridge"], a: "cooker" },
        { type: "blank", q: "US: apartment block = UK: block of ___ (flats).", options: ["flats"], a: "flats" },
        { type: "order", q: "Ordena: couch / sofa", words: ["couch", "(US)", "/sofa", "(UK)"], a: "couch (US) /sofa (UK)" }
      ]
    },
    {
      id: "u27-set7",
      title: "Set 7: Matching Rooms & Objects",
      questions: [
        { type: "mc", q: "Kitchen → refrigerator, sink, stove", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Bedroom → bed, closet, ___ (window).", options: ["window"], a: "window" },
        { type: "mc", q: "Living room → TV, couch, armchair", options: ["True", "False"], a: "True" },
        { type: "mc", q: "Bathroom → bathtub, shower, toilet", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Study → desk, bookcase, ___ (lamp).", options: ["lamp"], a: "lamp" },
        // Eliminada la coma dentro de "table," para evitar errores visuales
        { type: "order", q: "Match: dining room → table, chairs", words: ["table", "chairs"], a: "table, chairs" },
        { type: "mc", q: "Garage → car. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Garden/yard → grass, flowers, ___ (trees).", options: ["trees"], a: "trees" },
        { type: "mc", q: "Attic upstairs. True?", options: ["True", "False"], a: "True" },
        // Eliminadas las comas dentro de las palabras
        { type: "order", q: "Match: kitchen → refrigerator, stove, sink", words: ["refrigerator", "stove", "sink"], a: "refrigerator, stove, sink" }
      ]
    },
    {
      id: "u27-set8",
      title: "Set 8: House Ads Comprehension",
      questions: [
        { type: "mc", q: "Riverside Apartment: 3 bedrooms? (T/F)", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Riverside: ___ bathrooms. (2)", options: ["two"], a: "two" },
        { type: "mc", q: "Lake View has garage? (T/F)", options: ["True", "False"], a: "False" },
        { type: "blank", q: "Stone Hill: ___ bedrooms. (4)", options: ["four"], a: "four" },
        { type: "mc", q: "Lake View: big kitchen basement. True?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Riverside: first floor, ___ park next door.", words: ["beautiful"], a: "beautiful" },
        { type: "mc", q: "Stone Hill: bathtub + shower. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "All have ___ kitchen. (big)", options: ["big"], a: "big" },
        { type: "mc", "q": "Lake View: no garage, beautiful yard. True?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Stone Hill: old part Bridgewater, ___ furniture.", words: ["new", "stylish"], a: "new stylish" }
      ]
    },
    {
      id: "u27-set9",
      title: "Set 9: Describe Houses (Medium-Hard)",
      questions: [
        { type: "blank", q: "House has kitchen, living room, ___ bedrooms. (3)", options: ["three"], a: "three" },
        { type: "mc", q: "Apartment: 2 bathrooms, no garage → ", options: ["Riverside", "Lake View"], a: "Riverside" },
        { type: "blank", q: "Big kitchen basement: ___ View. (Lake)", options: ["Lake"], a: "Lake" },
        { type: "mc", q: "4 bedrooms, bathtub + shower = ", options: ["Stone Hill", "Riverside"], a: "Stone Hill" },
        { type: "blank", q: "No garage, beautiful : Lake View. (yard)", options: ["yard"], a: "yard" },
        { type: "order", q: "Describe: Riverside Apartment", words: ["3", "bedrooms,", "2", "bathrooms,", "park", "next", "door"], a: "3 bedrooms, 2 bathrooms, park next door" },
        { type: "mc", q: "Stone Hill: new stylish furniture. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "First floor: Riverside ___ (Apartment).", options: ["Apartment"], a: "Apartment" },
        { type: "mc", q: "All houses have big kitchens. True?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Lake View: quiet street, lake, no garage, beautiful yard.", words: ["quiet", "street", "lake,", "no", "garage,", "beautiful", "yard"], a: "quiet street lake, no garage, beautiful yard" }
      ]
    },
    {
      id: "u27-set10",
      title: "Set 10: Full House Vocabulary Challenge",
      questions: [
        { type: "mc", q: "Complete: kitchen (stove, sink, fridge), bedroom (bed, closet), bathroom (, toilet).", options: ["bathtub", "couch"], a: "bathtub" },
        // Convertido a MC porque pedía dos respuestas
        { type: "mc", q: "US/UK: couch/sofa, closet/___, refrigerator/___ (wardrobe/fridge).", options: ["wardrobe / fridge", "desk / oven"], a: "wardrobe / fridge" },
        { type: "order", q: "Master house: kitchen-living room-bedroom-bathroom.", words: ["kitchen,", "living", "room,", "bedroom,", "bathroom"], a: "kitchen, living room, bedroom, bathroom" },
        { type: "mc", q: "Quick: upstairs attic, downstairs basement. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Garage car / Garden grass / Study ___ (desk).", options: ["desk"], a: "desk" },
        { type: "mc", "q": "Riverside: 3 bed/2 bath, Lake View: no garage, Stone Hill: 4 bed + stylish furniture.", options: ["All true", "False"], a: "All true" },
        { type: "order", q: "Challenge: full house description.", words: ["kitchen", "with", "stove", "and", "fridge,", "living", "room", "with", "couch", "and", "TV,", "bedroom", "upstairs"], a: "kitchen with stove and fridge, living room with couch and TV, bedroom upstairs" },
        // Convertido a MC porque pedía dos respuestas
        { type: "mc", q: "Dining room: table + ___ / Bathroom: shower + ___ (chairs/bathtub).", options: ["chairs / bathtub", "bed / sink"], a: "chairs / bathtub" },
        { type: "mc", "q": "All rooms correct? kitchen/stove, bedroom/bed, study/desk.", options: ["True", "False"], a: "True" },
        { type: "order", q: "Ultimate: 3 houses comparison.", words: ["Riverside:", "3", "bed/2", "bath,", "Lake", "View:", "2", "bed/big", "kitchen,", "Stone", "Hill:", "4", "bed/new", "furniture"], a: "Riverside: 3 bed/2 bath, Lake View: 2 bed/big kitchen, Stone Hill: 4 bed/new furniture" }
      ]
    }
  ]
};
